<section
  class="scroll-projects"
  [class.scroll-projects--scrolling]="mobileScrollActive()"
  (mousemove)="onMouseMove($event)"
  (mouseleave)="clearHovered()"
>
  <div
    class="hover-label"
    [class.hover-label--visible]="hoveredProject() !== null"
    [style.transform]="'translate3d(' + mouseX() + 'px, ' + mouseY() + 'px, 0)'"
  >
    {{ hoveredProject()?.title }}
  </div>

  <div class="scene">
    <div
      class="cards-track"
      [style.transform]="getTrackTransform()"
    >
      <div
        #cardHitbox
        class="card-hitbox"
        *ngFor="let card of renderCards();let i = index;trackBy: trackByRenderId"
        [attr.data-render-id]="card.renderId"
        [style.transform]="getCardTransform(i)"
        [style.width.px]="getCardWidth(i)"
        [style.height.px]="getCardHeight(i)"
        [style.z-index]="getCardZIndex(i)"
        (click)="openProject(card, $event)"
      >
        <div
          class="card"
          [style.--hover-strength]="getCardHoverStrength(card.renderId)"
        >
          <img
            *ngIf="card.project.imgUrl"
            [src]="card.project.imgUrl"
            [alt]="card.project.title"
          >

          <span *ngIf="!card.project.imgUrl">
            {{ card.project.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div
    class="route-fade"
    [class.route-fade--visible]="isRouteLeaving()"
  ></div>
</section>
